import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { completeAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId, referral_code: localStorage.getItem("ftc_ref") || "" })
      .then(({ data }) => {
        localStorage.removeItem("ftc_ref");
        completeAuth(data);
        toast.success("SIGNED IN WITH GOOGLE");
        const next = localStorage.getItem("ftc_next");
        localStorage.removeItem("ftc_next");
        navigate(next || "/", { replace: true });
      })
      .catch((err) => {
        toast.error(formatApiError(err.response?.data?.detail));
        navigate("/auth", { replace: true });
      });
  }, [location, completeAuth, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center" data-testid="auth-callback">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-muted">
        Signing you in<span className="animate-blink">…</span>
      </p>
    </div>
  );
}
